import React, { useEffect, useState } from 'react';
import apis from '@src/apis';
import {
  SORT_VOICE_OPTIONS_FAVOURITE,
  VOICE_OWNERSHIP,
} from '@src/constants/voice';
import {
  COMMUNITY_SORT_TYPE,
  VOICE_HIGHTLIGHT_WEEK_PAGINATION_LIMIT,
} from '@src/constants/voiceLibrary';
import {
  DAYS_IN_LAST_DAYS_HIGHTLIGHT_WEEK,
  LIMIT_GET_DETAIL_LEADERBOARD_EVENT,
  TYPES,
} from '@src/constants/leaderboard';
import {
  dateInLastDays,
  getTopVoicesAndRankingListVoices,
} from '@src/services/leaderboard';
import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import useHandleFavouriteVoices from '@src/hooks/useHandleFavouriteVoices';
import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { useHistory } from 'react-router-dom';
import route from '@src/constants/route';
import { StyledVoiceLeaderboardContainer } from './index.style';
import Header from './Header';
import ListVoiceNewest from './ListVoiceNewest';
import Podium from '../VoiceLeaderboard/Podium';

const HightLightWeek = ({ open, onClose }) => {
  const [favouriteVoiceCodes, setFavouriteVoiceCodes] = useState([]);
  const [activeTab, setActiveTab] = useState(TYPES[0].value);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);
  const [eventShow, setEventShow] = useState(null);
  const [loadingVoices, setLoadingVoices] = useState(false);
  const [voicesDetailData, setVoicesDetailData] = useState();
  const [voicesNewestData, setVoicesNewestData] = useState();
  const [loadingVoiceDetail, setLoadingVoiceDetail] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const history = useHistory();

  const fetchFavouriteVoices = async () => {
    const data = await apis.favouriteVoices.getFavouriteVoices({
      sort: SORT_VOICE_OPTIONS_FAVOURITE[0].value,
    });
    if (data?.status) {
      setFavouriteVoiceCodes(
        data.result?.favouriteVoices?.map((voice) => voice.code) || [],
      );
    }
  };

  const fetchDetailLeaderboardEvent = async (eventId) => {
    setLoadingVoiceDetail(true);
    const data = await apis.leaderboard.getDetailLeaderboardEvent(
      eventId,
      LIMIT_GET_DETAIL_LEADERBOARD_EVENT,
    );
    if (data?.status) {
      setVoicesDetailData(data.result);
    }
    setLoadingVoiceDetail(false);
  };

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  const fetchLeaderboard = async () => {
    setLoadingLeaderboard(true);
    const data = await apis.leaderboard.getLeaderboard();
    if (data?.status) {
      setEventShow(data.result.previousEvent);
    }
    setLoadingLeaderboard(false);
  };

  const fetchVoices = async () => {
    setLoadingVoices(true);
    const data = await apis.voices.getVoicesV3({
      voiceOwnership: VOICE_OWNERSHIP.COMMUNITY,
      sort: COMMUNITY_SORT_TYPE.PUBLISH_AT_DESC,
      limit: VOICE_HIGHTLIGHT_WEEK_PAGINATION_LIMIT,
    });
    if (data?.status) {
      setVoicesNewestData(data.result?.voices || []);
    }
    setLoadingVoices(false);
  };

  const {
    handleFavoriteToggleRequest,
    addToQueuePostProcessingFavouriteVoices,
    handleErrorProcessingFavouriteVoices,
  } = useHandleFavouriteVoices({ favouriteVoiceCodes });

  useEffect(() => {
    if (!eventShow?.id) return;
    fetchDetailLeaderboardEvent(eventShow?.id);
  }, [eventShow?.id]);

  useEffect(() => {
    fetchLeaderboard();
    fetchFavouriteVoices();
  }, []);

  useEffect(() => {
    fetchVoices();
  }, []);

  const showInfoEvent =
    dateInLastDays(eventShow?.endDate, DAYS_IN_LAST_DAYS_HIGHTLIGHT_WEEK) &&
    eventShow;
  const onChangeVoice = (voice) => {
    dispatch(actions.synthesisRequest.updateVoice(voice));
    history.push(route.TTS);
  };

  const { topVoices } = getTopVoicesAndRankingListVoices(
    voicesDetailData,
    activeTab,
    eventShow,
  );
  if (loadingLeaderboard || loadingVoiceDetail || isMobile) return null;

  return (
    <>
      <CommonDialog
        open={open}
        width="1200px"
        styleTitle={{
          closeIcon: {
            top: '20px',
            right: '20px',
          },
        }}
        styleContent={{
          padding: '64px 24px 24px 24px',
        }}
        PaperProps={{
          sx: {
            height: '100%',
          },
        }}
        onClose={onClose}
        contentComponent={
          <StyledVoiceLeaderboardContainer>
            <Header
              showInfoEvent={showInfoEvent}
              eventShow={eventShow}
              activeTab={activeTab}
              handleChangeTab={handleChangeTab}
            />
            {showInfoEvent && (
              <Podium
                topVoices={topVoices}
                activeTab={activeTab}
                favouriteVoiceCodes={favouriteVoiceCodes}
                onFavoriteToggleRequest={handleFavoriteToggleRequest}
                onHandleFavoriteProcessingComplete={
                  addToQueuePostProcessingFavouriteVoices
                }
                onErrorProcessingFavouriteVoices={
                  handleErrorProcessingFavouriteVoices
                }
                setFavouriteVoiceCodes={setFavouriteVoiceCodes}
              />
            )}

            <ListVoiceNewest
              onChangeVoice={onChangeVoice}
              onClose={onClose}
              onErrorProcessingFavouriteVoices={
                handleErrorProcessingFavouriteVoices
              }
              onFavoriteToggleRequest={handleFavoriteToggleRequest}
              onHandleFavoriteProcessingComplete={
                addToQueuePostProcessingFavouriteVoices
              }
              favouriteVoiceCodes={favouriteVoiceCodes}
              isLoading={loadingVoices}
              voiceList={voicesNewestData}
              onCloseHighlightWeek={onClose}
            />
          </StyledVoiceLeaderboardContainer>
        }
        hideTitle
      />
    </>
  );
};

export default HightLightWeek;
